<template>
  <div class="wrap q-class">
    <span class="title">问题分类</span>
    <div class="moduleWrap">
      <div class="module" v-for="item in list" :key="item.id">
        <div class="headline" :style="{backgroundImage:item.img}">
          {{item.title}}
        </div>
        <ul class="ul-cls">
          <li v-for="item1 in item.leftList" :key="item1.id">
            <router-link :to="{path:`/5/detail/${item1.id}`}" v-if="item.title === '产品'">
              {{item1.listTitle}}
            </router-link>
            <router-link :to="{path:`/${item.id}/detail/${item1.id}`}" v-else>
              {{item1.listTitle}}
            </router-link>
          </li>
        </ul>
        <ul class="ul-cls">
          <li v-for="item1 in item.rightList" :key="item1.id">
            <router-link :to="{path:`/5/detail/${item1.id}`}" v-if="item.title === '产品'">
              {{item1.listTitle}}
            </router-link>
            <router-link :to="{path:`/${item.id}/detail/${item1.id}`}" v-else>
              {{item1.listTitle}}
            </router-link>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>

export default {
  data() {
    return {
      bgUrl: [
        // eslint-disable-next-line
        `url(${require('./images/bg1.png')})`,
        // eslint-disable-next-line
        `url(${require('./images/bg2.png')})`,
        // eslint-disable-next-line
        `url(${require('./images/bg3.png')})`,
        // eslint-disable-next-line
        `url(${require('./images/bg4.png')})`,
      ],
      list: [],
    };
  },
  created() {
    this.getInfo();
  },
  watch: {
    list() {
      const arr = this.list;
      for (let j = 0; j < arr.length - 1; j += 1) {
        // 两两比较，如果前一个比后一个大，则交换位置。
        for (let i = 0; i < arr.length - 1 - j; i += 1) {
          if (arr[i].id > arr[i + 1].id) {
            const temp = arr[i];
            arr[i] = arr[i + 1];
            arr[i + 1] = temp;
          }
        }
      }
      this.list = arr;
    },
  },
  methods: {
    getInfo() { // 产品介绍
      const header = ['管理', '交易', '产品介绍', '更多'];
      header.forEach((item, index) => {
        const obj = {
          id: '',
          img: '',
          title: '',
          allList: [],
          leftList: [],
          rightList: [],
        };
        this.$store.dispatch('list/getHelpList', {
          pageNum: 1,
          pageSize: 8,
          column_name: item,
        }).then((data) => {
          const { list } = data;
          if (item === '产品介绍') {
            obj.allList = list[0].list || [];
          } else {
            obj.allList = list || [];
          }
          if (obj.allList.length) {
            obj.id = index + 2;
            obj.title = item === '产品介绍' ? '产品' : item;
            this.bgUrl.forEach((item1, index1) => {
              if (index === index1) {
                obj.img = item1;
              }
            });
          }
          obj.allList.forEach((item1, index1) => {
            if (index1 < 4) {
              obj.leftList.push(item1);
            } else {
              obj.rightList.push(item1);
            }
          });
          obj.rightList = obj.rightList.slice(0, 4);
          this.list.push(obj);
        });
      });
    },
  },
};
</script>
